import HandleResponsesV2 from '@common/utils/handleApiResponsesV2';
import downloadFile from '@common/utils/downloadFile';
import axios from '../../../axios';

const actions = {
  async filter({ commit }, { params }) {
    try {
      let result = [];
      if (params.page === 1) {
        commit('SET_LOADING', true);
      } else {
        commit('paginationCheck', true);
      }
      result = await axios.put('/v2/transporter/wallet', { params });

      if (result && result.data) {
        commit('SET_LIST', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('SET_LOADING', false);
    }
  },

  async export(_, { params }) {
    try {
      return axios({ url: 'v2/transporter/wallet/export',
        method: 'GET',
        responseType: 'blob',
        params,
      });
    } catch (error) {
      return error;
    }
  },

  async show(_, walletId) {
    try {
      const params = {
        ids: [walletId],
        include_comments: true,
        include_attachments: true,
        include_consignee_attachments: true,
      };
      const result = await axios.put('/v2/transporter/wallet', { params });
      return result && result.data && result.data[0];
    } catch (error) {
      return HandleResponsesV2.status(error);
    }
  },

  async update({ commit }, payload) {
    try {
      const result = await axios.put('/v2/transporter/wallet/status',
        { data: payload });
      if (result && result.data) {
        commit('UPDATE_LIST', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.status(error);
    }
  },
  async addComment(_, payload) {
    try {
      const result = await axios.post('/v2/transporter/wallet/comment', payload);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addAttachment(_, formData) {
    try {
      const result = await axios.post('/v2/transporter/attachment/',
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async deleteAttachment(_, { attachmentId }) {
    try {
      const result = await axios.delete(`/v2/transporter/attachment/${attachmentId}`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getWalletCustomFields(_, { walletId }) {
    try {
      const result = await axios.get(`/v2/transporter/wallet/custom-fields/${walletId}/list`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getWalletTimelineAndRemarks(_, { walletId }) {
    try {
      const result = await axios.get(`/v2/transporter/wallet/${walletId}/timeline-remarks`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
};
export default actions;
